/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-11-06 20:40:06
 * @LastEditors: zhangxu
 * @LastEditTime: 2025-05-12 15:42:55
 */
import Vue from 'vue'

import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './utils/directives.js'
import library from './utils/library' //引入公共方法 过滤器
import { formatFloat } from './utils/index' //引入公共方法 js精度
import '@/styles/index.scss' // global css
import '@/styles/m-public.scss' // global css
import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog' // error log
import './permission' // permission control
import Permission from './utils/permission'
// import './mock' // simulation data
import * as directives from './directive'

import * as filters from './filters' // global filters
import DataInput from '@/components/DataInput'
Vue.prototype.library = library //挂载公共方法
Vue.prototype.formatFloat = formatFloat //挂载公共方法
Vue.component('data-input', DataInput) //初始化组件
import VueDND from 'awe-dnd'
Vue.use(VueDND)

import CKEditor from 'ckeditor4-vue'
Vue.use(CKEditor)

import moment from 'moment'
Vue.prototype.$moment = moment

//mathjax
import MathJax from './utils/mathJax.js'
Vue.prototype.MathJax = MathJax

const wx = require('weixin-js-sdk')
Vue.prototype.$wx = wx

/*
import 'muse-ui/lib/styles/base.less';
import 'muse-ui/lib/styles/theme.less';*/
// import 'muse-ui/dist/muse-ui.css'
// import 'material-icons/iconfont/material-icons.scss'
// import { Stepper, Button, Icon, Paper, DataTable, TextField, Snackbar, Chip, DateInput } from 'muse-ui'

Vue.use(Element, {
  size: Cookies.get('size') || 'small' // set element-ui default size /* i18n: (key, value) => i18n.t(key, value)*/
})
// import api from '@/api/api-source'
Element.Dialog.props.closeOnClickModal.default = false
// Vue.prototype.$api = api

// //高德地图
// import VueAMap from 'vue-amap'

// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: '47e5e7986830d478f151a9714a1acc6a',
//   plugin: [
//     'AMap.Autocomplete',
//     'AMap.PlaceSearch',
//     'AMap.Scale',
//     'AMap.OverView',
//     'AMap.ToolBar',
//     'AMap.MapType',
//     'AMap.PolyEditor',
//     'AMap.CircleEditor',
//     'AMap.Geocoder'
//   ],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// })
// //高德的安全密钥
// window._AMapSecurityConfig = {
//   securityJsCode: '693a5c2d8c576d1143ba42dfa8a3c54a'
// }
// 自定义指令
console.log(directives)
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Object.defineProperty(Vue.prototype, '$Utils', { value: { Permission } })

// Vue.use(Stepper)
// Vue.use(Button)
// Vue.use(Icon)
// Vue.use(Paper)
// Vue.use(DataTable)
// Vue.use(TextField)
// Vue.use(Snackbar)
// Vue.use(Chip)
// Vue.use(DateInput)

if (process.env.NODE_ENV === 'mock') {
  const { mockXHR } = require('../mock')
  mockXHR()
}

import ExportExcel from '@/components/export_excel'
Vue.use(ExportExcel)

Vue.config.productionTip = false

window.eventBus = new Vue()
import setCacheMixin from './utils/setCacheMixin'
Vue.mixin(setCacheMixin)

import enterKeySearch from './mixin/enterKeySearch'
Vue.mixin(enterKeySearch)

import './utils/datalistCommon'
Element.TableColumn.props.showOverflowTooltip = { type: Boolean, default: true }

new Vue({
  el: '#app',
  components: {
    DataInput
  },
  router,
  store,
  i18n,
  render: h => h(App)
})
